import theme from "@configs/theme";
/* -----------------Child components--------------- */
import { useThemeContext } from "@contexts/ThemeContext";
import { SessionConfigContainer } from "@features/session-config";
import { useDemoExamStore } from "@hooks/useDemoExamStore";
import { StatusBar } from "expo-status-bar";
import { PaperProvider } from "react-native-paper";
import type { ThemeProp } from "react-native-paper/lib/typescript/types";

const SessionCustomizeRoute = () => {
	const { isDarkMode } = useThemeContext();

	const { currentExam } = useDemoExamStore();

	const demoExamId = currentExam?.id;

	const finalTheme = theme(isDarkMode, demoExamId);

	return (
		<PaperProvider theme={finalTheme as unknown as ThemeProp}>
			<SessionConfigContainer />
			<StatusBar style="light" />
		</PaperProvider>
	);
};

export default SessionCustomizeRoute;
